<template>
<v-container
  fluid
  grid-list-md
>
<v-layout row wrap>
  <v-flex xs12>
    <v-toolbar flat>
      <h2>Классное руководство</h2>
      <v-dialog
        v-model="newClassheadDialog"
        scrollable persistent modal
        width="640"
        transition="dialog-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon class="mx-3" color="secondary" v-on="on" :disabled="!isadmin">
            <v-icon>
              add
            </v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="subtitle-1">
            Новый классный/ответственный
            <v-spacer></v-spacer>
            <v-btn icon small @click="dialogNewClose()"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-actions class="px-5">
            <v-text-field
            v-model="iCardId"
            label="Номер карты"
            counter="9"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn @click="dipSearchPerson()" :disabled="!iCardId || iCardId.length !== 9" color="primary">Искать по карте</v-btn>
          </v-card-actions>
          <v-card-text>
            <v-text-field
              :value="iPerson ? (iPerson.fullname + ' ' + (iPerson.position ? (iPerson.position.schoolid + ' ' + iPerson.position.name) : '')) : ''"
              label="Пользователь"
              :disabled="true"
            ></v-text-field>
            <v-autocomplete
              v-if="iPerson"
              flat
              label="Тип назначаемой должности"
              :items="[{ name: 'Классный руководитель', type: 'classhead' }, { name: 'Ответственный', type: 'uberclasshead' }]"
              v-model="iPositionType"
              item-text="name" item-value="type"
            ></v-autocomplete>
            <v-autocomplete
              v-if="iPositionType"
              flat
              label="Школа"
              :items="schools"
              v-model="iSchool"
              item-text="name" item-value="schoolid"
            ></v-autocomplete>

            <v-select
              v-if="iSchool && iPositionType === 'classhead'"
              :items="positions"
              v-model="iPosition"
              item-text="name" item-value="positionid"
              label="Подшефный класс"
            ></v-select>

          </v-card-text>
          <br /><br />

          <v-card-actions>
            <v-btn
              color="primary"
              :disabled="!iSchool"
              @click="addNew()"
            >
              Добавить
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text
              @click="dialogNewClose()"
            >Отмена</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-spacer></v-spacer>

      <v-autocomplete
      class="mx-3"
      dense
      label="школа"
      :items="schools"
      v-model="school"
      item-text="name"
      return-object
      clearable
      hide-details
      ></v-autocomplete>

      <v-checkbox
      class="mx-3"
      label="Классные"
      v-model="withClassheads"
      hide-details
      ></v-checkbox>

      <v-checkbox
      class="mx-3"
      label="Ответственные"
      v-model="withUberclassheads"
      hide-details
      ></v-checkbox>

      <v-text-field
      class="mx-3"
      label="Поиск"
      v-model="search"
      append-icon="search"
      style="max-width: 500px"
      :disabled="!items.length"
      outlined
      clearable
      hide-details
      flat
      ></v-text-field>
    </v-toolbar>
  </v-flex>

  <v-flex xs12>
    <v-data-table
      :headers="headers"
      :items="items"
      no-data-text="пусто"
      no-results-text="ничего не найдено"
      :items-per-page="-1"
      :search="search"
      flat
      dense
      hide-default-footer
      sort-by="positionname"
      :sort-desc="false"
    >
      <template v-slot:item.fullname="{ item }">
        <div>
          <router-link
          :to="{ name: 'person', params: { personid: item.personid } }"
          style="color: inherit; text-decoration: none"
          >
            <span style="font-size: 14px">
              {{ item.fullname }}
            </span>
            <v-icon small>call_made</v-icon>
          </router-link>
        </div>
      </template>
      <template v-slot:item.positionname="{ item }">
        <span v-if="item.positionname">{{ item.positionname }}</span>
        <span v-else>Ответственный по питанию</span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn class="px-1" color="error" x-small text @click="deleteItem(item)">
          <v-icon small>delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-flex>
  <Confirmation></Confirmation>
</v-layout>
</v-container>
</template>

<script>
import Confirmation from '@/components/Confirmation'
export default {
  name: 'Classheads',
  data: () => ({
    schools: [],
    positions: [],
    school: null,
    headers: [
      { text: 'id', value: 'personid', sortable: false },
      { text: 'фио', value: 'fullname', },
      { text: 'школа', value: 'schoolname', },
      { text: 'класс', value: 'positionname', },
      { text: 'действия', value: 'action', sortable: false },
    ],
    classheads: [],
    uberclassheads: [],
    search: '',
    withClassheads: true,
    withUberclassheads: true,
    newClassheadDialog: false,
    iSchool: null,
    iPositionType: null,
    iCardId: null,
    iPerson: null,
    iPosition: null,
    iClassheads: [],
    iUberclassheads: [],
  }),
  components: { Confirmation },
  methods: {
    async fetch () {
      try {
        if (this.schools.length === 0) {
          await this.fetchSchools()
        } else if (this.school) {
          await Promise.all([
            this.withClassheads ? this.fetchClassheads(this.school.schoolid) : null,
            this.withUberclassheads ? this.fetchUberclassheads(this.school.schoolid) : null
          ])
        }
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async fetchClassheads (schoolid) {
      try {
        const { meta, classheads } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-classheads',
          pl: {
            schoolid,
          }
        })
        if (this.iSchool && this.iSchool === schoolid) {
          this.iClassheads = classheads
        } else {
          this.classheads = classheads
        }
        return classheads
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async fetchUberclassheads (schoolid) {
      try {
        const { meta, uberclassheads } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-uberclassheads',
          pl: {
            schoolid
          }
        })
        if (this.iSchool && this.iSchool === schoolid) {
          this.iUberclassheads = uberclassheads
        } else {
          this.uberclassheads = uberclassheads
        }
        return uberclassheads
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async fetchSchools () {
      try {
        const { meta, schools } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-schools'
        })
        this.schools = schools
        return schools
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async dipSearchPerson () {
      try {
        const { meta, person } = await this.$store.dispatch('sioRequest', {
          topic: 'search-teacher',
          pl: {
            cardid: this.iCardId
          }
        })
        if (person.position.arestudents) {
          await this.$store.dispatch('confirm', `Назначить ученика ${item.fullname} классным руководителем? Уверены?`)
          this.iPerson = person
          this.$store.dispatch('snack', meta)
        }
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchPositions () {
      try {
        const { meta, positions } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-positions',
          pl: {
            schoolid: this.iSchool
          }
        })
        this.positions = positions.filter(p => p.arestudents)
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async addNew () {
      try {
        if (this.iPositionType === 'classhead') {
          if (this.classheads.find(cl => cl.personid === this.iPerson.personid && cl.positionid === this.iPosition)) {
            throw new Error('Пользователь уже назначен классным руководителем в выбранном классе')
          }
          const { meta } = await this.$store.dispatch('sioRequest', {
            topic: 'add-classhead',
            pl: {
              positionid: this.iPosition,
              personid: this.iPerson.personid
            }
          })
          this.$store.dispatch('snack', meta)
        } else if (this.iPositionType === 'uberclasshead') {
          if (this.uberclassheads.find(cl => cl.schoolid === this.iSchool && cl.personid === this.iPerson.personid)) {
            throw new Error('Пользователь уже назначен ответственным в выбранной школе')
          }
          const { meta } = await this.$store.dispatch('sioRequest', {
            topic: 'add-uberclasshead',
            pl: {
              schoolid: this.iSchool,
              personid: this.iPerson.personid
            }
          })
          this.$store.dispatch('snack', meta)
        }
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.dialogNewClose()
        this.fetch()
      }
    },
    async dialogNewOpen () {
      this.iSchool = null
      this.iPositionType = null
      this.iCardId = null
      this.iPerson = null
      this.iPosition = null
      this.newClassheadDialog = true
    },
    dialogNewClose () {
      this.iSchool = null
      this.iPositionType = null
      this.iCardId = null
      this.iPerson = null
      this.iPosition = null
      this.newClassheadDialog = false
      this.iClassheads = []
      this.iUberclassheads = []
    },
    async deleteItem (item) {
      try {
        if (!item.positionname) {
          await this.$store.dispatch('confirm', `Удалить ответственного по питанию ${item.fullname}?`)
          await this.$store.dispatch('sioRequest', {
            topic: 'delete-uberclasshead',
            pl: {
              personid: item.personid,
              uberclassheadid: item.uberclassheadid,
            }
          })
        } else {
          await this.$store.dispatch('confirm', `Удалить классного руководителя ${item.fullname}?`)
          await this.$store.dispatch('sioRequest', {
            topic: 'delete-classhead',
            pl: {
              personid: item.personid,
              classheadid: item.classheadid,
            }
          })
        }
        this.search = ''
        this.fetch()
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetch()
      }
    }
  },
  computed: {
    items () {
      return this.school ? [...this.classheads, ...this.uberclassheads] : []
    },
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    isadmin () {
      return this.scopes.includes('admin')
    },
  },
  watch: {
    profile (val) {
      if (val) this.fetch()
    },
    school (val) {
      if (!val) {
        this.classheads = []
        this.uberclassheads = []
      } else {
        this.fetch()
      }
    },
    async iSchool (val) {
      if (!val) {
        this.positions = []
      } else {
        await Promise.all([this.fetchPositions(), this.fetchClassheads(val), this.fetchUberclassheads(val)])
      }
    },
    withClassheads (val) {
      if (val) {
        this.fetch()
      } else {
        this.classheads = []
      }
    },
    withUberclassheads (val) {
      if (val) {
        this.fetch()
      } else {
        this.uberclassheads = []
      }
    },
  },
  async mounted () {
    if (this.profile) await this.fetch()
  },
}
</script>

<style lang="css">
</style>
